import * as React from "react";

const IconFavoriteFilled: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="currentColor">
            <polygon
                fill="currentColor"
                points="6.928 0 8.956 3.844 13.238 4.584 10.207 7.699 10.826 12 6.928 10.083 3.028 12 3.647 7.699 .619 4.584 4.899 3.844"
            />
        </svg>
    );
};

export default React.memo(IconFavoriteFilled);
